<button class="header__title-button" mat-button [matMenuTriggerFor]="menu" aria-label="Open main navigation menu" data-cy="header-menu-toggle">
  <mat-icon class="material-icons-outlined header__title-button-icon" aria-hidden="true">menu</mat-icon>
</button>
<mat-menu #menu="matMenu" aria-label="Main navigation links" data-cy="header-menu-panel">
    <ng-container *ngIf="translationsLoaded; else loading">
        <ng-container
          *ngFor="let item of menuItems"
        >
          <ng-container *appHasModuleAccess="item?.module">
      
            <button 
                mat-menu-item
                [routerLink]="item.route" 
                setColor
                [setColorRules]="[
                {
                    color: 'primaryColour',
                    events: ['hover']
                },
                {
                    color: 'primaryColour',
                    setIfClass: ['primaryColor'],
                    events: ['routerLinkActive']
                },
                ]"
                routerLinkActive="primaryColor" 
                class="primaryHoverColor" 
                [attr.data-cy]="'header-menu-item-' + item.localizationCode"
                *appHasFeature="item.feature"
            >
                <mat-icon class="material-icons-outlined" aria-hidden="true"
                >{{ item.icon }}</mat-icon> 
        
                <span appLocalizationPopupDirective [localizationCode]="item.localizationCode">
                    {{ translate.instant(item.localizationCode) }}
                </span>
        
            </button>
          </ng-container>
        </ng-container>
    </ng-container>

    <ng-template #loading>
        <ngx-skeleton-loader
            count="5"
            [theme]="{ 
                'height.px': 50
            }"
        ></ngx-skeleton-loader>
    </ng-template>
</mat-menu>